import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/utils/classUtils';
const SectionWrapper = ({ children, className, spacing = 'md', width = 'contained', ...otherProps }) => {
    return (_jsx("section", { className: cn(width === 'contained' && 'site-container', spacing === 'sm' && 'spacing-y-sm', spacing === 'md' && 'spacing-y-md', spacing === 'lg' && 'spacing-y-lg', className), ...otherProps, children: children }));
};
export default SectionWrapper;
